import { BaseCondition, INPUT_SEARCH_TYPE } from '@modules/feed/types';
import { LabelType } from 'generated/graphql';
import { FieldNames } from 'v2/core/entities/fields';
import {
  EmptyWhereClause,
  OperationType,
} from 'v2/core/services/queryBuilder/whereClause';
import { getWhereClauseForFieldName } from 'v2/core/services/queryBuilder/whereClauseGenerator';

export const getSearchWhereClauseFromBaseCondition = (
  baseCondition: BaseCondition,
) => {
  switch (baseCondition.type) {
    case LabelType.Aspect:
      return getWhereClauseForFieldName({
        fieldName: FieldNames.Entity,
        values: [baseCondition.id],
        op: OperationType.AND,
      });
    case LabelType.Reason:
      return getWhereClauseForFieldName({
        fieldName: FieldNames.Reason,
        values: [baseCondition.id],
        op: OperationType.AND,
      });
    case INPUT_SEARCH_TYPE.ADVANCED:
      return EmptyWhereClause;
    default:
      return {
        filter: {
          type: OperationType.AND,
          hybridSearchFilter: {
            query: '',
            queries: [baseCondition.id],
          },
        },
      };
  }
};
